// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/policy/v1/policy_step_form.proto" (package "c1.api.policy.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { SkippedAction } from "./shared_policy_outcomes";
import { ReassignedAction } from "./shared_policy_outcomes";
import { RestartAction } from "./shared_policy_outcomes";
import { Struct } from "../../../../google/protobuf/struct";
import { Form as Form$ } from "../../form/v1/form";
/**
 * @generated from protobuf message c1.api.policy.v1.Form
 */
export interface Form {
    /**
     * @generated from protobuf field: c1.api.form.v1.Form form = 1;
     */
    form?: Form$;
}
/**
 * @generated from protobuf message c1.api.policy.v1.FormInstance
 */
export interface FormInstance {
    /**
     * @generated from protobuf field: c1.api.form.v1.Form form = 1;
     */
    form?: Form$;
    /**
     * @generated from protobuf field: google.protobuf.Struct data = 2;
     */
    data?: Struct;
    /**
     * @generated from protobuf field: c1.api.policy.v1.FormInstanceState state = 3;
     */
    state: FormInstanceState;
    /**
     * @generated from protobuf oneof: outcome
     */
    outcome: {
        oneofKind: "completed";
        /**
         * @generated from protobuf field: c1.api.policy.v1.FormCompletedAction completed = 100;
         */
        completed: FormCompletedAction;
    } | {
        oneofKind: "restarted";
        /**
         * @generated from protobuf field: c1.api.policy.v1.RestartAction restarted = 101;
         */
        restarted: RestartAction;
    } | {
        oneofKind: "reassigned";
        /**
         * @generated from protobuf field: c1.api.policy.v1.ReassignedAction reassigned = 102;
         */
        reassigned: ReassignedAction;
    } | {
        oneofKind: "skipped";
        /**
         * @generated from protobuf field: c1.api.policy.v1.SkippedAction skipped = 103;
         */
        skipped: SkippedAction;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.policy.v1.FormCompletedAction
 */
export interface FormCompletedAction {
    /**
     * @generated from protobuf field: string user_id = 1;
     */
    userId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp completed_at = 2;
     */
    completedAt?: Timestamp;
}
/**
 * @generated from protobuf enum c1.api.policy.v1.FormInstanceState
 */
export enum FormInstanceState {
    /**
     * @generated from protobuf enum value: FORM_INSTANCE_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: FORM_INSTANCE_STATE_WAITING = 1;
     */
    WAITING = 1,
    /**
     * @generated from protobuf enum value: FORM_INSTANCE_STATE_DONE = 2;
     */
    DONE = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class Form$Type extends MessageType<Form> {
    constructor() {
        super("c1.api.policy.v1.Form", [
            { no: 1, name: "form", kind: "message", T: () => Form$ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.Form
 */
export const Form = new Form$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormInstance$Type extends MessageType<FormInstance> {
    constructor() {
        super("c1.api.policy.v1.FormInstance", [
            { no: 1, name: "form", kind: "message", T: () => Form$ },
            { no: 2, name: "data", kind: "message", T: () => Struct },
            { no: 3, name: "state", kind: "enum", T: () => ["c1.api.policy.v1.FormInstanceState", FormInstanceState, "FORM_INSTANCE_STATE_"] },
            { no: 100, name: "completed", kind: "message", oneof: "outcome", T: () => FormCompletedAction },
            { no: 101, name: "restarted", kind: "message", oneof: "outcome", T: () => RestartAction },
            { no: 102, name: "reassigned", kind: "message", oneof: "outcome", T: () => ReassignedAction },
            { no: 103, name: "skipped", kind: "message", oneof: "outcome", T: () => SkippedAction }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.FormInstance
 */
export const FormInstance = new FormInstance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FormCompletedAction$Type extends MessageType<FormCompletedAction> {
    constructor() {
        super("c1.api.policy.v1.FormCompletedAction", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "completed_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.FormCompletedAction
 */
export const FormCompletedAction = new FormCompletedAction$Type();
